import { IExtendablePaginatedDto, ILanguageDto, SimpleResult } from "../dto";
import { Api } from "../helpers";

export class LanguageApi {
  static async getAll(): Promise<ILanguageDto[] | undefined> {
    const response = await Api.get<
      SimpleResult<IExtendablePaginatedDto<ILanguageDto>>
    >("/api/v1/core/languages");

    return response?.data?.data?.items ?? [];
  }
}
